import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ChatPersonSearchPipe',
    standalone: false
})
export class ChatPersonSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(message => {
        if (message.senderProfile || message.receiverProfile) {
          return message.senderProfile.fullName.search(searchText) !== -1
            || message.senderProfile.enFullName.search(searchText) !== -1
            || message.receiverProfile.fullName.search(searchText) !== -1
            || message.receiverProfile.enFullName.search(searchText) !== -1;
        }
      });
    }
  }
}
